import { useCallback } from 'react';
import useSsrCookie from 'app/hook/common/useSsrCookie';
import qs from 'query-string';

export default function useDs() {
	const { getCookie, setCookie } = useSsrCookie();
	const setDsClickCodeReset = useCallback(() => setCookie('_dsClick', '', null, null, 1), [setCookie]);

	const getDsClickCode = useCallback(() => getCookie('_dsClick'), [getCookie]);
	const setDsClickCode = useCallback((text) => setCookie('_dsClick', text), [setCookie]);

	/* 클릭지표: 다음 페이지로 이동하면서 지표만을 위한 파라미터가 필요할때 */
	// (1)쿠키 변경 (2)useTrackingDataStory에서 n_logging 실행
	const handleDsClickUriChange = useCallback(
		(value) => {
			setCookie('_dsClick', value, null, null, 1);
		},
		[setCookie],
	);

	/* 현재 페이지에서 로그기록 : 레이어, 툴팁 등 uri가 안변할때 */
	// 현재 Uri에 value 추가, '/click/'이 추가됨 추가, n_click_logging 직접 실행
	// @params {string} value 지표에 쿼리스트링 형태로 전달할 값, windonw.location.search의 값 대신 원하는 값으로 덮어쓸 수 있다.
	const handleDsClickUriUnchange = useCallback((value, options) => {
		const { pathname = document.location.pathname } = options || {};
		const searchParams = qs.parse(document.location.search);
		const customSearchParams = qs.parse(value);
		const mergedValue = Object.assign(searchParams, customSearchParams);
		const valueParam = `?${qs.stringify(mergedValue)}`;

		if (typeof window.n_click_logging === 'function') {
			window.n_click_logging(`${document.location.protocol}//${document.location.host}/click${pathname}${valueParam}`);
		}
	}, []);

	// Layout의 설정을 off하고 커스텀 송출
	const handleDsCustom = useCallback(
		(value = '') => {
			const cookie = getDsClickCode() ? `${getDsClickCode()}&` : getDsClickCode();
			let checkJsLoadTime;
			try {
				let count = 0;
				checkJsLoadTime = setInterval(() => {
					if (typeof window.n_logging === 'function') {
						window.n_logging(`${cookie}${value}`);
						setDsClickCodeReset();
						clearInterval(checkJsLoadTime);
					}
					count += 1;
					if (count > 50) {
						setDsClickCodeReset();
						clearInterval(checkJsLoadTime);
						console.log('dsLog: not working');
					}
				}, 150);
			} catch (err) {
				console.log(err);
			}
		},
		[setDsClickCodeReset, getDsClickCode],
	);

	return {
		setDsClickCodeReset,
		getDsClickCode,
		setDsClickCode,
		handleDsClickUriChange,
		handleDsClickUriUnchange,
		handleDsCustom,
	};
}
